import i18n from '@/helper/i18n';

export default function formatLimitSelection(value) {
  return i18n.te(`debtors.limitSelectOptions.${value}`)
    ? i18n.t(`debtors.limitSelectOptions.${value}`)
    : value;
}
